import * as types from '../../constants/actionTypes'

export const setVisibilityAction = payload => ({
  type: types.ROUTE_VISIBILITY,
  payload
})
